<template>
  <v-row align-content="center">
    <v-col class="py-0 mx-auto" md="12">
      <v-row>
        <v-col class="white mx-auto" md="6" style="height: 100vh">
          <v-spacer class="py-16"></v-spacer>
          <div class="px-8">
            <v-row class="mb-4" justify="center">
              <v-col sm="6" lg="4" class="text-center">
                <img src="@/assets/images/success.png">
              </v-col>
            </v-row>
            <div class="fs-32 mb-5 text-center font-weight-bold">
              Link berhasil dikirim
            </div>
            <div class="fs-18 text-center color-disable">
              <span>Cek email anda kemudian buka link yang telah kami kirimkan untuk melanjutkan proses</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "success-send-email",

  mounted(){

    setTimeout( () => {
      this.$router.push({ name: 'login'})
    }
    , 4000);

  },
};
</script>

<style>
</style>